import { useEffect, useState } from 'react'

import { Maybe } from 'aem-libs-ts/src/types/utility'

const defaultDebounce = 500

type Handler<TArgs> = (args: TArgs) => void

export function useDelayedHandler<TArgs>(handler: Maybe<Handler<TArgs>>, delay: number = defaultDebounce) {
  const [args, setArgs] = useState<TArgs>()

  useEffect(() => {
    if (!args || !handler) {
      return
    }
    const delayedHandler = setTimeout(() => {
      handler(args)
    }, delay)

    return () => {
      clearTimeout(delayedHandler)
    }
  }, [args])

  return { setDelayedArgs: setArgs }
}
